import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PsButtonTuner } from 'stencilSetup';
import { MainNavigation } from '../MainNavigation';
import { Logo } from 'theSource/components/Logo';
import { DesktopPopOver } from 'theSource/components/Header/components/DesktopPopOver';
import { useSubscriberQuery } from 'theSource/queries';
import './scss/MainHeader.css';
import { ROUTES } from 'theSource/app/routes';
import { ChatBot } from 'components/ChatBot';

interface MainHeaderProps {
  chatBot?: boolean;
  hideDrawer?: boolean; // Add the hideDrawer prop
}

export const MainHeader: FC<MainHeaderProps> = ({
  chatBot,
  hideDrawer = false,
}) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { subscriber } = useSubscriberQuery({ restrictAdmin: true });

  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  const handleToggleNavigation = () => {
    setIsNavigationOpen(!isNavigationOpen);
  };

  const navInbox = () => {
    navigate(ROUTES.main.inbox.path);
  };

  const subscriberName =
    (subscriber?.data.first_name.value as string) +
    ' ' +
    (subscriber?.data?.last_name?.value as string);

  return (
    <>
      <nav className="main-header">
        <div className="header-nav-trigger">
          {chatBot && (
            <div className="MobileandTabletChatBot ml-n5">
              <ChatBot renderDefault={false} showText={false} />
            </div>
          )}
          {!hideDrawer && (
            <PsButtonTuner
              buttonId="main-nav-trigger"
              label={t('openMenu')}
              level="secondary"
              isIcon={true}
              icon="list"
              extraClass="border-0"
              onClick={handleToggleNavigation}
              otherData={[
                {
                  attribute: 'aria-label',
                  value: t('openMenu'),
                },
              ]}
            />
          )}
        </div>
        <div className="header-nav-logo">
          <Logo />
        </div>
        {!hideDrawer && (
          <>
            {' '}
            <div className="header-subscriber d-none d-lg-flex">
              {subscriberName}
            </div>
            <div className="header-alerts d-none d-lg-flex">
              <ps-button
                id="go-to-inbox-button"
                type="bell"
                icon="bell"
                label={t('openInbox')}
                level="tertiary"
                is-icon={true}
                onClick={() => navInbox()}
              />
            </div>
            <div className="header-settings d-none d-lg-flex">
              <DesktopPopOver />
            </div>
          </>
        )}
      </nav>
      <MainNavigation
        isOpen={isNavigationOpen}
        setIsNavigationOpen={setIsNavigationOpen}
      />
    </>
  );
};
